import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import HelpCenterPage from './HelpCenter/Help';
import FaqCard from './HelpCenter/FAQs';
import TicketsTable from './HelpCenter/TicketsTable';
import baseURL from '../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageLoader from '../../../Reusable/PageLoader'; // <-- PageLoader

const HelpCenter = () => {
    const [tickets, setTickets] = useState([]);
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [refreshTickets, setRefreshTickets] = useState(0);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            // await new Promise(resolve => setTimeout(resolve, 4000));

            const [ticketsRes] = await Promise.all([
                fetch(`${baseURL}/user/tickets`, { credentials: "include" }),
            ]);

            const [ticketsData, faqsData] = await Promise.all([
                ticketsRes.json(),
            ]);

            if (!ticketsRes.ok) throw new Error(ticketsData.message || "Failed to load tickets.");

            setTickets(ticketsData || []);
        } catch (err) {
            console.error("Error fetching help center data:", err);
            toast.error(err.message || "Failed to load help center data.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData, refreshTickets]);

    const handleTicketSubmitted = () => {
        setRefreshTickets(prev => prev + 1);
    };

    return (
        <DashboardLayout>
            {loading && <PageLoader />}

            {!loading && (
                <>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#666',
                            mb: 2,
                            textAlign: 'left',
                            mt: 2,
                            fontWeight: '600',
                            fontSize: { xs: '1.2rem', md: '1.5rem' }
                        }}
                    >
                        Help Center
                    </Typography>

                    <HelpCenterPage onTicketSubmitted={handleTicketSubmitted} />

                    <Typography
                        variant="h6"
                        sx={{
                            mt: 4,
                            mb: 2,
                            fontWeight: '600',
                            textAlign: 'left',
                            fontSize: { xs: '1.2rem', md: '1.5rem' }
                        }}
                    >
                        Your Support Tickets
                    </Typography>
                    <TicketsTable tickets={tickets} />

                    <Typography
                        variant="h6"
                        sx={{
                            mt: 4,
                            mb: 2,
                            fontWeight: '600',
                            textAlign: 'left',
                            fontSize: { xs: '1.2rem', md: '1.5rem' }
                        }}
                    >
                        Frequently Asked Questions
                    </Typography>
                    <FaqCard />
                </>
            )}
        </DashboardLayout>
    );
};

export default HelpCenter;
